import { createSlice } from '@reduxjs/toolkit';
import type { KeycloakProfile } from 'keycloak-js';

export interface IAuthState {
    isAuthenticated: boolean;
    tokens?: Tokens;
    header?: string;
    profile?: KeycloakProfile;
    info?: Record<string, string>;
}

export type Tokens = {
    idToken: string;
    refreshToken: string;
    token: string;
};

export const initialState: IAuthState = {
    isAuthenticated: false,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        initAuth: () => {},
        setTokens: (state, action) => {
            state.tokens = action.payload;
        },
        setAuthHeader: (state, action) => {
            state.header = action.payload;
        },
        setIsAuthenticated: (state, action) => {
            state.isAuthenticated = action.payload;
        },
        setProfile: (state, action) => {
            state.profile = action.payload;
        },
        setInfo: (state, action) => {
            state.info = action.payload;
        },
    },
});

export const authSelectors = {
    isAuthenticatedSelector: (state: IAuthState) => state.isAuthenticated,
    getAuthHeader: (state: IAuthState) => state.header,
    getUserInfo: (state: IAuthState) => state.info,
    getUserProfile: (state: IAuthState) => state.profile,
};
